module.exports = __webpack_public_path__ + "img/vertical_4_3_8003.55a2c52b.png";